export const translations = {
  en: {
    nav: {
      about: 'About',
      gallery: 'Gallery',
      videos: 'Videos',
      services: 'Services',
      packages: 'Packages',
      vendors: 'Vendors',
      contact: 'Book A Tour',
    },
    hero: {
      welcome: 'Welcome To The',
      title: 'Haros Event Venue!',
      subtitle: "It's Nice To Meet Y'ALL",
      explore: 'Explore',
    },
    about: {
      title: 'About Us',
      description: 'The luxurious Haros Event Center is the epitome of refinement and elegance, situated on a sprawling 47 acre property. Boasting a spacious 10,500 sq ft of climate-controlled event space, the venue can accommodate up to 400 guests in style. From the indoor fireplace and bridal suite to the optional TV screens and projector, every detail has been carefully considered to ensure an unparalleled experience. The event center also features a serving area and bar/beverage area, making it the perfect choice for any special occasion. Foyer perfect for displaying cherished photos. As guests enter, they are greeted by an elegant entrance table, where a guestbook can be featured to leave wishes for the celebration.',
      card1: 'Available For Planning Your Special Events',
      card2: 'Perfect For Proposals And Engagement Parties',
    },
    gallery: {
      title: 'Gallery',
    },
    videos: {
      title: 'Videos',
    },
    services: {
      title: 'Our Exquisite Services',
      subtitle: 'Where elegance meets country charm',
      amenities: 'Venue Amenities',
      additional: 'Additional Offerings',
      optional: 'Optional:',
      accommodations: 'Accommodations',
      accommodationsDesc: 'Convenient hotel accommodations in downtown Alvarado, TX',
      amenityList: [
        'Temperature-controlled venue',
        'Capacity for 450 guests',
        '60-inch round tables with elegant chairs',
        'Set-up and take-down of tables and chairs',
        'Bridal suite with vanity and seating',
        'Food serving area',
        'Bar and beverage area',
        'Charming fireplace',
        'Professional bartender services',
        'Spacious dance floor with DJ or band space',
        'Foyer for showcasing cherished moments',
      ],
      additionalList: [
        'Rehearsals available by appointment',
        'Ample parking space',
        'Provided security services',
        'Flexible payment plans',
        'Optional:',
        'TVs with projector in the ballroom',
        'Event decor including head table decor, linens, charger plates, chair covers/bands, and centerpieces',
        'Professional platers and servers',
        'Post-event cleaning',
      ],
    },
    contact: {
      title: 'Contact Us',
      subtitle: "We'd love to hear from you",
    },
    footer: {
      copyright: 'Copyright',
      location: 'Alvarado, Texas',
    },
  },
  es: {
    nav: {
      about: 'Acerca de',
      gallery: 'Galería',
      videos: 'Videos',
      services: 'Servicios',
      packages: 'Paquetes',
      vendors: 'Proveedores',
      contact: 'Reservar un Tour',
    },
    hero: {
      welcome: 'Bienvenido a',
      title: '¡Haros Event Venue!',
      subtitle: 'Es un Placer Conocerte',
      explore: 'Explorar',
    },
    about: {
      title: 'Acerca de Nosotros',
      description: 'El lujoso Centro de Eventos Haros es la máxima expresión de refinamiento y elegancia, ubicado en una extensa propiedad de 47 acres. Con un amplio espacio de eventos de 10,500 pies cuadrados con clima controlado, el lugar puede acomodar hasta 400 invitados con estilo. Desde la chimenea interior y la suite nupcial hasta las pantallas de TV y proyector opcionales, cada detalle ha sido cuidadosamente considerado para garantizar una experiencia sin igual. El centro de eventos también cuenta con un área de servicio y un área de bar/bebidas, lo que lo convierte en la opción perfecta para cualquier ocasión especial. Vestíbulo perfecto para exhibir fotos preciadas. Cuando los invitados entran, son recibidos por una elegante mesa de entrada, donde se puede presentar un libro de visitas para dejar deseos para la celebración.',
      card1: 'Disponible Para Planificar Tus Eventos Especiales',
      card2: 'Perfecto Para Propuestas Y Fiestas de Compromiso',
    },
    gallery: {
      title: 'Galería',
    },
    videos: {
      title: 'Videos',
    },
    services: {
      title: 'Nuestros Servicios Exquisitos',
      subtitle: 'Donde la elegancia se encuentra con el encanto campestre',
      amenities: 'Amenidades del Lugar',
      additional: 'Ofertas Adicionales',
      optional: 'Opcional:',
      accommodations: 'Alojamientos',
      accommodationsDesc: 'Alojamientos hoteleros convenientes en el centro de Alvarado, TX',
      amenityList: [
        'Lugar con temperatura controlada',
        'Capacidad para 450 invitados',
        'Mesas redondas de 60 pulgadas con sillas elegantes',
        'Montaje y desmontaje de mesas y sillas',
        'Suite nupcial con tocador y asientos',
        'Área de servicio de comida',
        'Área de bar y bebidas',
        'Encantadora chimenea',
        'Servicios de bartender profesional',
        'Pista de baile espaciosa con espacio para DJ o banda',
        'Vestíbulo para exhibir momentos preciados',
      ],
      additionalList: [
        'Ensayos disponibles con cita previa',
        'Amplio estacionamiento',
        'Servicios de seguridad proporcionados',
        'Planes de pago flexibles',
        'Opcional:',
        'TVs con proyector en el salón de baile',
        'Decoración de eventos que incluye decoración de mesa principal, manteles, platos de carga, fundas/bandas de sillas y centros de mesa',
        'Plateros y servidores profesionales',
        'Limpieza post-evento',
      ],
    },
    contact: {
      title: 'Contáctanos',
      subtitle: 'Nos encantaría saber de ti',
    },
    footer: {
      copyright: 'Derechos de autor',
      location: 'Alvarado, Texas',
    },
  },
};
